// src/models/administrativo/ConfigTEF.ts
export enum IntegradorTEFEnum {
    Nenhum = 0,
    MSiTef = 1,
    SuperTef = 2,
    Cielo = 3,
    Banrisul = 4,
    Manual = 5
}

export class ConfigTEF {
    id: number;
    filialId: number;
    nomeTerminal: string;
    numSerialPOS: string;
    cnpjCreden: string;
    ipTerminal:string;
    posId?:number | null;
    integrador: IntegradorTEFEnum | null;


    constructor(id: number, filialId: number, nomeTerminal:string,
        numSerialPOS: string, cnpjCreden: string, ipTerminal: string,
      posId: number, integrador: IntegradorTEFEnum | null = IntegradorTEFEnum.MSiTef) {
      this.id = id;
      this.filialId = filialId;
      this.nomeTerminal = nomeTerminal;
      this.numSerialPOS = numSerialPOS;
      this.cnpjCreden = cnpjCreden;
      this.ipTerminal = ipTerminal;
      this.posId = posId;
      this.integrador = integrador;
    }
  }
